module.exports = __webpack_public_path__ + "../resources/images/emptySearch_calendar-ae2d0262898d1b9a0905063e4db22de8.svg";